import { z } from 'zod';
import { contentBase } from './content';
import { metadata } from './helpers';

export const recoveryExpertiseContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    title: z.string(),
    underline: z.string(),
    image: z.string(),
    compensation_items: z.array(
      z.object({
        label: z.string(),
      })
    ),
    cards: z.array(
      z.object({
        title: z.string(),
        description: z.string(),
        position: z.number(),
        background_image: z.string(),
        badge: z.object({
          label: z.string(),
          icon: z.string(),
        }),
      })
    ),
  }),
});

export const contentTypeRecoveryExpertiseContentSchema = contentBase.extend({
  content: recoveryExpertiseContentSchema,
});

export type ContentTypeRecoveryExpertiseContentInput = z.infer<
  typeof contentTypeRecoveryExpertiseContentSchema
>;
